import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestedBatch(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_harvested_batch/${organization_id}/fetch_harvested_batch/${harvested_batch_id}`
    );
  },
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_harvested_batch/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  }
};
